export default __webpack_public_path__ + "static/media/hotel.c51d0078.svg";